import { type PropsWithChildren, forwardRef } from 'react';

import styles from './InfinityLoaderArea.css';

export const InfinityLoaderArea = forwardRef<HTMLDivElement, PropsWithChildren>(function LoaderArea({ children }, ref) {
  return (
    <div className={styles['container']} ref={ref}>
      {children}
    </div>
  );
});
